/* 项目 全局属性定义 */

import Request, { env } from '@ysfe/request'
import VueRouter from 'vue-router'

import Apis from './apis'
import { createRequest, IResponseData } from './apis/request'
import { envs } from './data/envs'
import { logLevel } from './data/runtime'
import { createRouter } from './router'
import Store from './store'
import Logger, { ILogger } from './utils/Logger'
// import { createSensors } from './utils/Sensors'

export { createRequest } from './apis/request'

/** @定义 日志打印工具 */
export const logger: ILogger = new Logger(logLevel)

/** @定义 后端接口集合 */
export const apis: Apis = new Apis()

/** @定义 全局状态管理 */
export const store: Store = new Store()

/** @定义 通信适配器: 前/后端请求 */
export const request: Request<IResponseData> = createRequest({ logger, envName: 'production' })

/** @定义 路由 */
export const router: VueRouter = createRouter()

/** @定义 神策埋点工具 */
// export const sensors = createSensors(env(envs, 'production').current.name)
